import { render, staticRenderFns } from "./PlantingSocFarmerEdit.vue?vue&type=template&id=d9e7404c"
import script from "./PlantingSocFarmerEdit.vue?vue&type=script&lang=js"
export * from "./PlantingSocFarmerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports